import React, { useEffect, useMemo, useState } from "react";
import { ButtonGroup, Col, Dropdown, Form, Modal, Row } from "react-bootstrap";
import { dataSource } from "../../../../services/dataSource";
import { LANG_CATS, LANG_V2} from "../../../../shared/Data/typeDirs";
import Language_v2 from "../../../../shared/Objects/language_v2";
import { genId } from "../../../../shared/utils";
import ButtonWithLoadSpinner from "../../../buttonWithLoadSpinner";
import { useNotificationContext } from "../../../revised_components/contextProviders/notificationContext";
import { useSource, useSourceReducer } from "../../sourceContext";
import { useControlReducer } from "../../controlContext";
import { useSchemaReducer } from "../../schemaContext";

export function LanguageHeader( /*{children, objectMetadata, childContainerRef, settings, setSettings}*/ ) {
  const source = useSource()
  const sourceReducer = useSourceReducer()
  const controlReducer = useControlReducer()
  const schemaReducer = useSchemaReducer()
  const [saveAsName, setSaveAsName] = useState('')
  const [showSaveAsModal, setShowSaveAsModal] = useState(false)
  const displayNotif = useNotificationContext()
  let [selected, setSelected] = useState(false)
  let [langs, setLangs] = useState(false)
  let [NEW_LANG, setNewLang] = useState(false)
  const saveAsNameConflict = useMemo(()=>{
    return langs && langs.find(itm => itm.name === saveAsName) 
  }, [saveAsName, langs])

  const selectedLanguage = useMemo(()=>{ 
    if(!langs || !NEW_LANG || !selected) return {}
    let selectedLanguage = [ NEW_LANG, ...langs ].find(itm => itm.name === selected)
    setTimeout(()=>{
      schemaReducer({type:'_init', schemas: selectedLanguage.getSchemas()})
      sourceReducer({type:'_init', source: selectedLanguage.getSource()})
      controlReducer({type:'_init', controls: selectedLanguage.getDefaultContent()})
    })
    return selectedLanguage
  }, [ selected, controlReducer, schemaReducer, sourceReducer, NEW_LANG, langs ] )
  
  useEffect(()=>{
    let stillAlive = true
    let timeoutId = setTimeout(async ()=>{
      if(NEW_LANG && langs) return
      console.log('initializing languages????')
      let new_lang, _langs
      if(!NEW_LANG){
        new_lang = await newLanguage()
      }
      if(!langs){
        _langs = await initLangs()
      }
      if(!stillAlive) return
      setNewLang(new_lang)
      setLangs(_langs)
    })
    return ()=>{
      stillAlive = false
      clearTimeout(timeoutId)
    }
  }, [NEW_LANG, langs])
  // const selectedLanguage = useMemo(()=>{
  //   return [ NEW_LANG, ...langs ].find(itm=>itm.name === selected)
  // }, [selected])


  return (
    <Row className="lst-container">
      <Col className="lst-col">
        <Row>
          <Form.Label className="lst-selected-label" column xs={5}>
            {selected ? 'Editing: ' : 'Select a Language File: '}
          </Form.Label>
          <Col xs={7}>
            <Dropdown onSelect={(val, evt) => {
              // console.log('setting selected in dropdown', val, evt.target.eventKey)
              setSelected(val)
            }}>
              <Dropdown.Toggle className="lst-drop" variant="outline-info">
                {selected ? selected : 'No File Selected'}
              </Dropdown.Toggle>
              <Dropdown.Menu  popperConfig={{strategy:'fixed'}} renderOnMount={true}>
                {langs && NEW_LANG && [NEW_LANG, ...langs].map((itm, idx) => <Dropdown.Item key={idx} eventKey={itm.name}>{itm.name}</Dropdown.Item>)}
              </Dropdown.Menu>
            </Dropdown>
          </Col>
        </Row>
      </Col>
      <Col className="lst-col">
        <Dropdown as={ButtonGroup}>
          <ButtonWithLoadSpinner
            className="lst-drop"
            onClick={async() => {
              // console.log('is this getData?', getData())
              if (selected === '(NEW)') {
                return setShowSaveAsModal(true)
              } else {
                await saveLanguage({source}, selectedLanguage, displayNotif)
                await initLangs(setLangs)
                // setSelected('(NEW)')
                // setTimeout(()=>setSelected(newLang.name))
              }
            }} variant="outline-activated"
          >
            Save
          </ButtonWithLoadSpinner>
          <Dropdown.Toggle split variant="activated" />
          <Dropdown.Menu  popperConfig={{strategy:'fixed'}} renderOnMount={true}>
            <Dropdown.Item onClick={() => setShowSaveAsModal(true)}>Save As</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
        <Modal show={showSaveAsModal} onHide={() => {
          setSaveAsName('')
          setShowSaveAsModal(false)
        }}>
          <Modal.Title>Name New Language File</Modal.Title>
          <Modal.Body>
            <Form.Control
              className={saveAsNameConflict ? 'invalid-name' : ''}
              type="text"
              onChange={evt => setSaveAsName(evt.target.value)}
            />
          </Modal.Body>
          <Modal.Footer>
            <span style={{ color: 'red' }}>{saveAsNameConflict ? 'Language files must have unique names.' : ''}</span>
            <ButtonWithLoadSpinner
              onClick={async () => {
                let newLang = await saveLanguageAs({source}, selectedLanguage, saveAsName, displayNotif)
                await initLangs(setLangs)
                setSelected('(NEW)')
                setTimeout(()=>setSelected(newLang.name))
                setShowSaveAsModal(false)
              }}
              disabled={saveAsNameConflict}
              variant="outline-activated"
            >
              Save As
            </ButtonWithLoadSpinner>
          </Modal.Footer>
        </Modal>
      </Col>
    </Row>
  )
}


async function saveLanguage(data, selectedLanguage, displayNotif) {
  // if(!data) return
  let { source } = data
  let newLangData = { ...selectedLanguage, ...source }
  console.log('about to send this lang', newLangData)
  // return
  let res
  try {
    res = await dataSource('remDb')[LANG_V2].put(newLangData)
    displayNotif('success', 'Saved Language successfully!')
  } catch (e) {
    console.warn('saveLanguage failed with:', e)
    displayNotif('danger', `Failed saving language: ${e.message}`)
  }
  console.log(' got this back ', res)
  return res
}

async function saveLanguageAs(data, selectedLanguage = {}, newName, displayNotif) {
  let newData = { source: {} }
  for (let cat of LANG_CATS) {
    newData.source[cat] = data.source[cat].map(itm => ({ ...itm, rel_id: genId() }))
  }

  let newSelectedLanguage = new Language_v2({ ...selectedLanguage, ...newData.source, _id: genId(), name: newName.trim() })
  return saveLanguage(newData, newSelectedLanguage, displayNotif)

}

async function newLanguage(){
  let all = {}
  for(let type of LANG_CATS){
    all[type] = await dataSource('remDb')[type].toArray()
  }
  return new Language_v2({...all, name:'(NEW)', _id:genId()})
}


async function initLangs(setLangs){
    
    
  let finalLangs = await dataSource('remDb')[LANG_V2].toArray()
  console.log('final langs', finalLangs)
  let newLangs = []
  for(let lang of finalLangs) {
    let newlang = await dataSource('remDb')[LANG_V2].get({_id:lang._id})
    newLangs.push(newlang)
  }
  // let testlangobj = new Language_v2(finalLang)
  newLangs = newLangs.map(itm=>new Language_v2(itm))
  console.log('put a thing maybe', finalLangs)
  // let mas = Mastercategory.constructFromDBData(testlangobj.source[MAS][0])
  // console.log('transform?', mas)
  return newLangs

  // let res = await dataSource('remDb')[LANG_V2].get({name:'testdata'})
  // console.log('got this res', res)
}
